import React from "react";
import { Helmet } from "react-helmet-async";
import { Navbar, Footer } from "../../components/shared";
import RecentFamilyList from "./RecentFamilyList";
import RecentPendingFamilyList from "./RecentPendingFamilyList";
import FamilyList from "./FamilyList";
import FamilySearch from "./FamilySearch";
import FamilyAreaWiseListPrint from "./FamilyAreaWiseListPrint";
import FamilyAreaWiseListContactPrint from "./FamilyAreaWiseListContactPrint";
import FamilyCountByKootam from "./FamilyCountByKootam";
import FamilyMemberListCSV from "./FamilyMemberListCSV";
import '../general/General.css';
import { useCheckAccess } from "../../utils/Utilities";
import { useSelector } from "react-redux";

const FamilyAdmin = () => {
  useCheckAccess('FamilyRO'); // Check if the user is logged in (if no user data, redirect to login)
  const user = useSelector((state) => state.user);
  return (
    <>
      <Navbar />
      <Helmet>
        <title>ஸ்ரீ பொன்னாச்சி அம்மன் திருக்கோவில்கள் | குடும்ப நிர்வாகம்</title>
        <link rel="canonical" href="/family" />
      </Helmet>

      <FamilySearch />
      <RecentFamilyList /> {/* Family List component displaying recent families */}

      {/* ✅ Show these only if user has 'FamilyAdmin' role */}
      {user?.roles?.includes('FamilyAdmin') && (
        <>
          <RecentPendingFamilyList />
          <FamilyAreaWiseListPrint />
        </>
      )}
      {user?.roles?.includes('SuperUser') && (
        <>
          <FamilyCountByKootam />
          <FamilyAreaWiseListContactPrint />
          <FamilyList />
          <FamilyMemberListCSV />
        </>
      )}
      <Footer />
    </>
  );
};

export default FamilyAdmin;
